import React, { useEffect, useState } from 'react';

import api from '../utils/api';
import Loader from '../lib/components/Loader';
import { NavLink } from 'react-router-dom';

const clampWeek = week => Math.min(Math.max(Number(week) || 1, 1), 17);

const H2HCardContent = ({ teamData, i }) => {
    const { name, url, logo, teamPoints, teamProjectedPoints } = teamData;
    return <div key={name} style={i === 1 ? { textAlign: 'end'} : {}}>
        <h5 style={{ fontSize: '12px' }}>{name}</h5>
        <div>
            <img src={logo} alt={`${name} logo`} style={{ height: '50px', width: '50px' }}/>
            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{teamPoints}</div>
            <div style={{ fontStyle: 'italic', fontSize: '10px' }}>{teamProjectedPoints}</div>
        </div>
    </div>
};

const BRCardContent = ({ teamData, place, lastWinningPlace }) => {
    const { name, url, logo, teamPoints, teamProjectedPoints } = teamData;
    const isWinningPlace = place <= lastWinningPlace;
    
    return (
        <div 
            key={name} 
            className={`d-flex align-items-center px-2 py-2 mb-1 ${
                isWinningPlace ? 'bg-success bg-opacity-75' : 'bg-danger bg-opacity-75'
            } border-start border-4 ${
                isWinningPlace ? 'border-success' : 'border-danger'
            }`}
        >
            <div className={`fw-bold me-2 ${
                isWinningPlace ? 'text-success-emphasis' : 'text-danger-emphasis'
            }`} style={{ minWidth: '20px', fontSize: '14px' }}>
                {place}
            </div>
            <img 
                src={logo} 
                alt={`${name} logo`} 
                className="me-2 rounded"
                style={{ height: '32px', width: '32px' }}
            />
            <div className="flex-fill text-truncate">
                <div className="fw-medium" style={{ fontSize: '13px' }}>
                    {name}
                </div>
            </div>
            <div className="text-end ms-2">
                <div className={`fw-bold ${
                    isWinningPlace ? 'text-success-emphasis' : 'text-danger-emphasis'
                }`} style={{ fontSize: '16px' }}>
                    {teamPoints}
                </div>
                <div className="fst-italic" style={{ fontSize: '9px' }}>
                    {teamProjectedPoints}
                </div>
            </div>
        </div>
    )
};

const MatchupCard = ({ matchup }) => {
    const managerNames = Object.keys(matchup);
    const isBR = managerNames.length !== 2;
    return <div className="card">
        <div className="card-body" style={isBR ? { padding: '4px' } : { }}>
            {!isBR ? 
                <div className="progress">
                    <div className="progress-bar bg-success" style={{ width: `${matchup[managerNames[0]].winProbability}%`}}>{matchup[managerNames[0]].winProbability}%</div>
                    <div className="progress-bar bg-danger" style={{ width: `${matchup[managerNames[1]].winProbability}%`}}>{matchup[managerNames[1]].winProbability}%</div>
                </div> : null
            }
            <div style={isBR ? {display: 'flex', flexDirection: 'column'} : { display: 'flex', justifyContent: 'space-between'}}>
                {managerNames.map((managerName, i) => {
                    return (
                        <NavLink 
                            to={`/league/${managerName}`} 
                            style={{ color: 'inherit', textDecoration: 'inherit'}} 
                            key={`${managerName}-link`}
                        >
                            {isBR ? 
                                <BRCardContent teamData={matchup[managerName]} place={i+1} lastWinningPlace={managerNames.length / 2}/> : 
                                <H2HCardContent teamData={matchup[managerName]} i={i}/>
                            }
                        </NavLink>
                    )
                })}
            </div>
        </div>
    </div>
}

const Scoreboard = ({ userData }) => {
    const [matchups, updateMatchups] = useState([]);
    const [week, updateWeek] = useState(null);
    const [loading, updateLoading] = useState(true);
    const [isError, updateIsError] = useState(false);

    useEffect(() => {
        api.get('/api/v2/matchups/currentWeek')
            .then(({ data }) => updateWeek(clampWeek(data.currentWeek)))
            .catch(() => updateWeek(1));
    }, []);

    useEffect(() => {
        if (!week) {
            return;
        }
        updateLoading(true);
        api.get(`/api/v2/matchups?week=${week}`).then(({ data }) => {
            updateMatchups(data);
            updateLoading(false);
            updateIsError(false);
        }).catch((err) => {
            updateIsError(true)
            updateLoading(false);
        });
    }, [week]);

    return (
        <div>
            <div style={{ maxWidth: '500px' }}>
                <h2>Scoreboard</h2>
                <div>
                    <select className="form-select full-width" value={week ?? ''} onChange={(e) => updateWeek(e.target.value)}>
                        {Array(17).fill(0).map((_, i) => (
                            <option key={i} value={i + 1}>Week {i + 1}</option>
                        ))}
                    </select>
                </div>
                <div className="">
                    {loading ? <Loader/> : 
                        isError ? <div className="alert alert-danger">Error loading matchups!</div> :
                        matchups.length === 0 ? <div className="alert alert-info">No matchups found!</div> :
                        matchups.map((matchup, i) => {
                            return (
                                <div key={i} className="mb-3">
                                    <h3>{matchup.matchupTitle}</h3>
                                    {matchup.matchups.map((m, i) => <MatchupCard key={`matchup-${i}`} matchup={m}/>)}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default Scoreboard;